import useMediaQuery from './useMediaQuery'

/**
 * "Is this a phone-width viewport": below 768px, Tailwind's `md`.
 *
 * Narrower than `useIsMobile` (below 1024px) on purpose. Some decisions are
 * about how much room there is rather than about mobile in general. A tablet
 * between 768 and 1023px still gets the mobile layout (stacked rows, no
 * pagination), but it is wide enough for the card grid, so the asset index
 * screens only force list view below this cut-off (MYD-560).
 */
const useIsPhone = (): boolean => useMediaQuery('(max-width: 767px)')

export default useIsPhone
